export default __webpack_public_path__ + "static/media/Tesla-vs-Edison.c7da474f.jpg";